import { useState } from "react";
import { Play } from "lucide-react";

const ARCADE_SRC =
  "https://demo.arcade.software/video/Twm5kBFsMXI0AEpjrUG4?embed&embed_mobile=tab&embed_desktop=tab&show_copy_link=true";

/**
 * Interactive product tour (Arcade). Click-to-load so the marketing page
 * never pays for a third-party iframe on first paint.
 */
export default function ProductTourEmbed() {
  const [active, setActive] = useState(false);

  return (
    <div className="glass-card overflow-hidden rounded-3xl">
      <div className="relative w-full" style={{ paddingBottom: "56.25%" }}>
        {active ? (
          <iframe
            src={ARCADE_SRC}
            title="Introducing WeKIT Career Clarity 360"
            loading="lazy"
            allowFullScreen
            allow="clipboard-write; autoplay"
            className="absolute inset-0 h-full w-full"
            style={{ colorScheme: "light" }}
          />
        ) : (
          <button
            type="button"
            onClick={() => setActive(true)}
            aria-label="Play the WeKIT Career Clarity 360 product tour"
            className="absolute inset-0 flex flex-col items-center justify-center gap-4
              bg-gradient-to-br from-primary/15 via-background to-background
              transition-colors hover:from-primary/25
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <span className="grid h-16 w-16 place-items-center rounded-full bg-primary text-primary-foreground shadow-lg">
              <Play className="h-6 w-6 translate-x-[1px]" aria-hidden="true" />
            </span>
            <span className="font-display text-base font-semibold text-foreground sm:text-lg">
              Take the 2-minute tour
            </span>
            <span className="max-w-xs px-6 text-center text-sm text-muted-foreground">
              See the discovery walk, your Career DNA™ and the roadmap — no sign-up needed.
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
